export default __webpack_public_path__ + "common/images/content_placeholders/ad.png";